import { Directive, ViewContainerRef } from '@angular/core';

@Directive({
    selector: '[nav2ndLevelHost]',
    standalone: false
})
export class Nav2ndLevelHostDirective {

  constructor(public viewContainerRef: ViewContainerRef) { }

}
